import "@assets/css/components/SideBarCollapse/style.css";

import { Menu, MenuItem, Sidebar, SubMenu, menuClasses } from "react-pro-sidebar";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import { getCursos } from "@helpers/httpRequests/httpRequestsCursos/httpRequestsCursos";
import SidebarItems from "@components/general/SideBarCollapse/SidebarItems/SidebarItems";
import UserContext from "@context/User/UserContext";
import { getCategoriasCursos } from "@helpers/httpRequests/httpRequestsCategoriasCursos/httpRequestsCategoriasCursos";
import multiViewComponentsPaths from "@helpers/multiViewComponentsPaths/multiViewComponentsPaths";
import useWindowResize from "@customHooks/useWindowResize";
import { getCursosLicencia } from "@helpers/httpRequests/httpRequestsLicencias/httpRequestsLicencias";
import typesCodigosNotificacionUsuario from "@helpers/types/typesCodigosNotificacionUsuario";
import { useTranslation } from "react-i18next";
import { getCurrentLanguage } from "@helpers/idiomas/validation/getCurrentLanguage";
import { validarHayConvenio } from "@helpers/httpRequests/httpRequestConvenios/httpRequestConvenios";
import { obtenerEstadisticasEstudiante, recuperarExamenDiagnostico, validateExamenRealizado } from "@helpers/httpRequests/httpRequestsGruposLectura/httpRequestsGruposLectura";
import { NotificationManager } from "react-notifications";

const SiderBarCollapse = ({ isSidebarActive, setIsSidebarActive, activeView, handleChangeComponent, rtl }) => {
	const {t} = useTranslation();
	
	const prefixCategorias = "categoria_";

	const [defaultActiveItem] = SidebarItems;

	const { contextValue: userContextValue, setContextValue: setUserContextValue } = useContext(UserContext);

	const { idCredencial } = userContextValue.usuarioLogeado;

	const { usuarioLogeado, notificacionesUsuario = [] } = userContextValue;

	let { idGrupo, rol, servicioActivo, estatusCredencial, correo, folioContrato, idPerfil } = usuarioLogeado;

	const lang = getCurrentLanguage();

	const [activeItem, setActiveItem] = useState(activeView ? SidebarItems.find((item) => item.path === activeView) : defaultActiveItem);

	const [showCollapseListadoCursos, setShowCollapseListadoCursos] = useState(false);

	const [cursoSeleccionado, setCursoSeleccionado] = useState(false);

	const [notificacionesDisponiblesForoAyuda, setNotificacionesDisponiblesForoAyuda] = useState(
		notificacionesUsuario.find((noti) => noti.codigoNotificacion === typesCodigosNotificacionUsuario.nuevoPostForoAyuda && noti.leida === 0) !== undefined
	);

	const [categorias, setCategorias] = useState([]);

	const [cursos, setCursos] = useState([]);

	const [cursosLicencia, setCursosLicencia] = useState([]);

	const [cursosCategoria, setCursosCategoria] = useState([]);

	const [menuRootStyles, setMenuRootStyles] = useState({});

	const cursosFiltrados = cursos.filter((curso) => cursosLicencia.find((cursoLicencia) => cursoLicencia.codigoCurso === curso.codigoCurso));

	const categoriasFiltradas = categorias.filter((categoria) => cursosFiltrados.some((curso) => curso.idCategoria === categoria.idCategoria));

	const [usuarioConConvenio, setUsuarioConConvenio]= useState(false);

	const [semanaAvance, setSemanaAvance] = useState(1);

	const [diagnosticoHabilitado, setDiagnosticoHabilitado] = useState(false);
	
	

	useWindowResize();

	const obtenerUltimoEjercicio= (codigo) => {
        let infoUsuario = {};

        if(codigo === 'Sin avance'){
          infoUsuario.semana = 1;
          return infoUsuario;
        }
      
        const semana = parseInt(codigo.slice(0, 2), 10);
        // const dia = parseInt(codigo.slice(2, 4), 10);
        // const sesion = parseInt(codigo.slice(4, 7), 10);
        // const ejercicio = parseInt(codigo.slice(7, 9), 10);

        infoUsuario.semana = semana;


        return infoUsuario;
    }

	const handleItemClick = (item) => {
		setActiveItem(item);

		if (item.path === multiViewComponentsPaths.misCursos) {
			if (!isSidebarActive) {
				setIsSidebarActive(!isSidebarActive);
			}

			setShowCollapseListadoCursos(!showCollapseListadoCursos);
		} else {
			handleChangeComponent(item.path);

			setCursoSeleccionado(false);
		}
	};

	const handleSeleccionSubMenuCursos = async ({ currentTarget }) => {
		try {
			const idCategoria = parseInt(currentTarget.id.split("-")[2]);

			setCursosCategoria({
				...cursosCategoria,
				[`${prefixCategorias}${idCategoria}`]: cursosFiltrados.filter((curso) => curso.idCategoria === idCategoria),
			});
		} catch (error) {
			console.log("Error al consultar el curso seleccionado: ", error);
		}
	};

	const abrirCursoLectura = () => {

		if(diagnosticoHabilitado){
			return NotificationManager.warning('Tienes una evaluación diagnóstica pendiente, realizala primero.')
		}

		window.open(`https://virtual.globalclickmexico.com/lectura_2/initCurso.php?nombreUsuario=${correo}${usuarioConConvenio ? `&folioContrato=${folioContrato}&semanaAvance=${semanaAvance}` : ''}`);
	}

	const validarExamenResuelto = (codigoExamen, infoEvaluacion)=>{
		return new Promise(async(resolve, reject)=>{
		try{
			const verificacion = await validateExamenRealizado({idPerfil, codigoExamen });
			
			resolve(true);
		}catch(error){
			setDiagnosticoHabilitado(true)
			reject(false);
		}
		})
	}

	useEffect(() => {
		if (!isSidebarActive) {
			setShowCollapseListadoCursos(false);
		}

		setMenuRootStyles({
			[`.${menuClasses.subMenuContent}`]: {
				// ...isSidebarActive && { width: '230px'}
			},
		});
	}, [isSidebarActive]);

	useEffect(() => {
		const consultarCategorias = async () => {
			try {
				const { data: categorias } = await getCategoriasCursos();

				setCategorias(categorias);
			} catch (error) {
				console.log("Error al consultar las categorías: ", error);
			}
		};

		const consultarCursos = async () => {
			try {
				const { data: cursos } = await getCursos();

				setCursos(cursos);
			} catch (error) {
				console.log("Error al consultar los cursos: ", error);
			}
		};

		const consultarCursosLicencia = async () => {
			try {
				const {
					data: { cursos },
				} = await getCursosLicencia(idCredencial);

				setCursosLicencia(JSON.parse(cursos));
			} catch (error) {
				console.log("Error al consultar los cursos de la licencia: ", error);
			}
		};

		const getEstadisticasUsuario = async() => {
			try {
				console.log('Correo Usuario: ', correo);
				const estadisticas = await obtenerEstadisticasEstudiante({ correo });
				console.log(estadisticas);
	
				const infoSemanaAvance = obtenerUltimoEjercicio(estadisticas.avancePersonal.ultimoEjercicio);
	
				console.log(infoSemanaAvance);
	
				setSemanaAvance(infoSemanaAvance.semana);
	
			} catch (error) {
				console.log('Error al obtener el avance del usuario: ', error);
			}
		}

		const obtenerExamenDiagnostico = async () => {
			try {
				//Recuperar el examen diagnostico habilitado mas reciente para que se muestre la info aqui.
				const { data: resultados } = await recuperarExamenDiagnostico();

				const { data } = resultados;
				console.log(data);

				//En caso de que ya se tenga el examen resuelto, hay que verificarlo con el codigo del examen y el perfil del usuario.

				const evaluacionRealizada = await validarExamenResuelto(data.codigoExamen);

				console.log("EVALUACION REALIZADA:", evaluacionRealizada);


			} catch (error) {
				console.log("Error al recuperar el examen de diagnostico: ", error);
			}
		}
		
			

		consultarCategorias();

		consultarCursos();

		consultarCursosLicencia();

		const validarConvenio = async () => {
			if (rol === 'asesor_lectura') {
				setUsuarioConConvenio(true);
				return;
			}

			try {
				const results = await validarHayConvenio(folioContrato);

				// console.log("El folio tiene convenio con la uveg");
				setUsuarioConConvenio(true);
				getEstadisticasUsuario();
				obtenerExamenDiagnostico();


			} catch (error) {
				console.log("Error al validar el convenio");
			}
		}

		if(rol === 'asesor_lectura' || rol === 'lectura_veloz'){
			validarConvenio();
		}

	}, []);

	const handleCursoSelection = (codigoCurso) => {

		if(codigoCurso === "LV23") {
			abrirCursoLectura();
			return;
		}

		setCursoSeleccionado(true);

		setUserContextValue({
			...userContextValue,
			codigoCursoSeleccionado: codigoCurso,
			ultimaLeccionTomada: "",
			codigoSeccionSeleccionada: codigoCurso + "01",
		});

		// document.getElementById("sidebar-item-cursos").click();

		handleChangeComponent(multiViewComponentsPaths.curso);

	};

	const getTooltipTitle = (item) => (item.path === multiViewComponentsPaths.foroAyuda ? t(item.title(notificacionesDisponiblesForoAyuda)) : t(item.title));

	const getSidebarIcon = (item) => (item.path === multiViewComponentsPaths.foroAyuda ? item.icon(notificacionesDisponiblesForoAyuda) : item.icon);

	return (
		<Sidebar style={{ zIndex: "1000" }} collapsed={!isSidebarActive} breakPoint="md" backgroundColor="#00152A" className="sidebar-scroll sidebar">
			<div className="pb-5">
				<Menu
					menuItemStyles={{
						button: ({ level, active, disabled }) => {
							if (level === 0) {
								return {
									backgroundColor: cursoSeleccionado ? "#00152A" : active ? "#FF9900" : undefined,
									color: cursoSeleccionado ? "#FFF" : active ? "#000" : "#FFF",
								};
							}
						},
					}}
					rootStyles={menuRootStyles}>
					{SidebarItems.map((item, idxSidebarItem) => {
						// Si el rol no está permitido, no se renderiza el item
						if (!item.permittedTo.includes(rol)) return null;

						// if (idGrupo !== null && idGrupo !== undefined) rol = "empleado";

						return (
							<div key={idxSidebarItem} id={item.id}>
								{item.path === multiViewComponentsPaths.misCursos ? (
									estatusCredencial ? 
										<OverlayTrigger key={idxSidebarItem} placement="top" delay={{ show: 250, hide: 400 }} overlay={<Popover id={`popover`}>
											<Popover.Header as="h3">{t(item.title)}</Popover.Header>
											<Popover.Body>
												{t(item.descripcion)}
											</Popover.Body>
										</Popover>}>
										{/* Menu de categorias al estar oculta la sidebar */}
											<SubMenu
												rootStyles={{
													[`.${menuClasses.button}`]: {
														backgroundColor: cursoSeleccionado ? "#FF9900!important" : undefined,
														color: cursoSeleccionado ? "#000" : "#FFF",
														"&:hover": {
															backgroundColor: "#FF9900!important",
															color: "#000",
															transition: 'all .2s ease'
														},
													},
												}}
												label={t(item.title)}
												icon={item.icon}>
												{categoriasFiltradas.map((categoria, idxCategoria) => (
													t(categoria.nombre) !== 'Languages' && (
														<SubMenu
														key={idxCategoria}
																style={{fontWeight: "bold"}}
														rootStyles={{
															[`.${menuClasses.button}`]: {
																backgroundColor: "#ff9900!important",
																color: "#000",
																"&:hover": {
																	backgroundColor: "#ffcc00!important",
																	color: "#000",
																	transition: 'all .2s ease'
																},
															},
														}}
														id={`categoria-curso-${categoria.idCategoria}`}
														label={t(categoria.nombre)}
														onClick={handleSeleccionSubMenuCursos}>
														{cursosCategoria[`${prefixCategorias}${categoria.idCategoria}`]?.map((curso, idxCursoCategoria) => (
															<MenuItem
																onClick={() => {
																	handleCursoSelection(curso.codigoCurso);
																}}
																key={idxCursoCategoria}
																id={`curso-${curso.codigoCurso}`}>
																{t(curso.nombre)}
															</MenuItem>
														))}
													</SubMenu>
													)
												))}
											</SubMenu>
										</OverlayTrigger>
									: null
								) : item.path === multiViewComponentsPaths.misPagos ? (
									<OverlayTrigger key={idxSidebarItem} placement="right" delay={{ show: 250, hide: 400 }} overlay={<Popover id={`popover`}>
									<Popover.Header as="h3">{getTooltipTitle(item)}</Popover.Header>
									<Popover.Body>
										{t(item.descripcion)}
									</Popover.Body>
								</Popover>}>
										<MenuItem
											id={item.id}
											active={activeItem === item}
											className={item.classNames}
											icon={getSidebarIcon(item)}
											key={idxSidebarItem}
											onClick={() => handleItemClick(item)}
											rootStyles={{
												[`.${menuClasses.button}`]: {
													"&:hover": {
														backgroundColor: "#FF9900!important",
														color: "#000!important",
														transition: 'all .2s ease'
													},
												},
											}}>
											{getTooltipTitle(item)}
										</MenuItem>
									</OverlayTrigger>
								) : servicioActivo ? (
									// Renderización
									<OverlayTrigger key={idxSidebarItem} placement="right" delay={{ show: 250, hide: 400 }} overlay={<Popover id={`popover`}>
									<Popover.Header as="h3">{getTooltipTitle(item)}</Popover.Header>
									<Popover.Body>
										{t(item.descripcion)}
									</Popover.Body>
								</Popover>}>
										<MenuItem
											id={item.id}
											active={activeItem === item}
											className={item.classNames}
											icon={getSidebarIcon(item)}
											key={idxSidebarItem}
											onClick={() => handleItemClick(item)}
											rootStyles={{
												[`.${menuClasses.button}`]: {
													"&:hover": {
														backgroundColor: "#FF9900!important",
														color: "#000!important",
														transition: 'all .2s ease'
													},
												},
											}}>
											{getTooltipTitle(item)}
										</MenuItem>
									</OverlayTrigger>
								) : null}
							</div>
						);
					})}
				</Menu>
			</div>
		</Sidebar>
	);
};

export default SiderBarCollapse;
